import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    width: '65%',
    height: '100%',
    backgroundColor: 'white',
    color: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingTop: 30,
    paddingBottom: 53,
    paddingLeft: 20,
    paddingRight: 20,
  },
  rightColumn: {
    width: '35%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 20,
    paddingTop: 40,
    paddingBottom: 53,
    paddingLeft: 30,
    paddingRight: 80,
  },
  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    lineHeight: 1.4,
  },
  paragraph: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 400,
    paddingBottom: 10,
  },
  button: {
    backgroundColor: '#0070f3',
    borderRadius: '12px',
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 900,
    textDecoration: 'none',
    textAlign: 'center',
    paddingVertical: 15,

    width: '100%',
  },

  // Images section
  imageRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 20,
  },
  image: {
    objectFit: 'cover',
    borderRadius: '15px',
    width: '100%',
    height: '100%',
  },
});
